<template>
  <div class="property-examine1"  style="margin-top: 10px;margin-left: 30px;">
      <el-card shadow="hover" style="box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);">
          <el-row :gutter="20">
              <el-col :span="7">
                  <el-button type="primary">
                    智能合规评估
                  </el-button>
              </el-col>
          </el-row>

          <el-row :gutter="20" type="flex" justify="end">
              <el-col :span="12" v-if="currentName === ''">
                  <el-input v-model="keywords" placeholder="请输入资产名称..." style="width: 300px; float: right"
                      @keydown.enter.native="doSearch">
                      <el-button slot="append" icon="el-icon-search" @click="doSearch"></el-button>
                  </el-input>
              </el-col>
          </el-row>
          <component v-bind:is="currentName" @changeName="changeName"></component>
          <div class="table" v-if="currentName === ''" style="margin-top: 20px; width: 100%">
              <el-table :data="tableData" border style="width: 100%" :header-cell-style="{ background: '#f5f5f5' }">

                   <el-table-column type="index" label="序号" width="80" align="center">
                  </el-table-column>

                  <el-table-column prop="registrationId" label="资产登记编号"  width="192"  align="center">
                  </el-table-column>

                  <el-table-column prop="companyName" label="企业名称" width="230"   align="center">
                  </el-table-column>

                  <el-table-column prop="assetName" label="资产名称"  width="260"   align="center">
                  </el-table-column>

                  <el-table-column prop="industryName" label="所属行业"  width="160"   align="center">
                  </el-table-column>

                  <el-table-column prop="isReview" label="是否已审查"  width="100"   align="center">
                    <template slot-scope="scope"> 
                        {{ scope.row.isReview ? '是' : '否' }}
                    </template>
                  </el-table-column>

                  <el-table-column prop="legalOpinionFile" label="法律意见书"  width="120"   align="center">
                    <template slot-scope="scope">
                      <div v-if="scope.row.legalOpinionFile">
                        <el-button 
                          type="text" 
                          size="small"
                          @click="downloadFile(scope.row.legalOpinionFile)"
                        >
                          {{ scope.row.legalOpinionFile }}
                        </el-button>
                      </div>
                      <div v-else>
                        <el-tag type="danger" size="small">未生成</el-tag>
                      </div>
                    </template>
                
                  </el-table-column>
                  


                  <el-table-column prop="state" label="状态"  width="100"  align="center">
                      <template slot-scope="scope">
                          <span :style="getStatusStyle(scope.row.state)">{{ scope.row.state }}</span>
                      </template>
                  </el-table-column>

                  <el-table-column prop="createTime" label="登记时间"   width="180"  align="center">
                    <template slot-scope="scope">
                      {{ formatDateTime(scope.row.createTime) }}
                    </template>
                  </el-table-column>

                  <el-table-column label="操作"  width="177"   align="center">
                      <template slot-scope="scope">
                          <el-button v-if="scope.row.isLegalOpinion" size="mini" type="success"
                              @click="handleEdit(scope.row)">导出报告</el-button>
                        <el-button v-if="scope.row.isLegalOpinion" size="mini" type="primary"
                              @click="handleView(scope.row)">详情</el-button>
                          <el-button v-else size="mini" type="primary" @click="handleView(scope.row)">审核</el-button>
                      </template>
                  </el-table-column>
              </el-table>
          </div>
      </el-card>
      <div v-if="currentName === ''" class="block" style="position: absolute; left: 38%;margin-top: 20px">
          <el-pagination layout="prev, pager, next" :total="boardsTotal" :page-size="10" :current-page="currPage"
              @current-change="handleCurrentChange">
          </el-pagination>
      </div>
  </div>
</template>

<script>
// import AddBoardContent from "@components/AddBoardContent";
import AddBoardContent from "../../../components/AddBoardContent"

export default {
  name: "PublishBoard",
  data() {
      return {
          boardsTotal: 1,
          currPage: 1,
          keywords: '',
          currentName: '',
          tableData: [],
          columnWidth: 180,
      }
  },
  components: {
      AddBoardContent
  },
  watch: {},
  mounted() {
      this.initTableData('');
  },
  methods: {

        // 格式化日期时间
      formatDateTime(dateTime) {
        if (!dateTime) return '-'
        
        const date = new Date(dateTime)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')
        const hours = String(date.getHours()).padStart(2, '0')
        const minutes = String(date.getMinutes()).padStart(2, '0')
        
        return `${year}-${month}-${day} ${hours}:${minutes}`
      },
      handleCurrentChange(val) {
          this.currPage = val;
          this.initTableData(this.keywords);
      },
      initTableData(keyword) {

          let user = JSON.parse(window.localStorage.getItem('user'));
          //console.log("useId:  " + user.id)

          this.getRequest('/web/dataAssets/approve/queryIntelligentByPage?&currPage=' + this.currPage + '&pageSize=' + 8).then(resp => {
            if (resp) {
                this.boardsTotal = resp.data.total;
                this.tableData = resp.data.list;
            }
            //console.log(resp.data);

          })
      },
      doSearch() {
          //处理搜索逻辑
          this.initTableData(this.keywords);
      },
      changeName(name) {
          //console.log(this.currentName)
          this.currentName = name;
          if (name === '') {
              this.initTableData('');
              this.$store.commit('REMOVE_CURRENT_BOARD_ID');
          }
      },
      handleDelete(obj) {
          this.$confirm('是否永久删除名为：【' + obj.assetName + '】的数据资产？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
          }).then(() => {
              this.getRequest("/web/dataAssets/delete?registrationId=" + obj.registrationId).then(resp => {
                  if (resp && resp.status === 200) {
                      this.$message.success('删除成功');
                      this.initTableData('');
                  }
              });
          }).catch(() => {
              this.$message({
                  type: 'info',
                  message: '已取消删除'
              });
          });
      },
      publishedSwitch(obj) {
          this.getRequest('/web/changeBoard/published?id=' + obj.id + '&published=' + obj.published).then(resp => {
          });
      },
      goToRegistration() {
          this.$router.push('/index/data-registration');
      },
      getStatusStyle(state) {
          switch (state) {
              case '录入中': return { color: '#67C23A' };
              case '待审核': return { color: '#409EFF' };
              case '待初审': return { color: '#409EFF' };
              case '待复审': return { color: '#409EFF' };
              case '待终审': return { color: '#409EFF' };
              case '审核驳回': return { color: '#F56C6C' };
              case '审核通过': return { color: '#409EFF' };
              default: return {};
          }
      },
      handleView(row) {
          // 跳转到审核页面
          this.$router.push({
              path: '/index/data-review-ai',
              query: { registrationId: row.registrationId }
          });
      },
      handleEdit(row) {
          this.$router.push({
              path: '/index/data-registration',
              query: { registrationId: row.registrationId, mode: 'edit' }
          });
      }
  }
}
</script>



<style>
/* 表头样式 */
.property-examine1 .el-table__header th {
  text-align: center;
  font-size: 14px;
  color: rgb(46, 44, 44);
  background-color: #f5f5f5 !important;
}


</style>